import type { InjectionKey } from "vue";

/** Provided to a toolbar item SCAOverflowContainer renders into its "⋯" menu for lack of room. */
export interface OverflowMenu {
  close: () => void;
}

export const SCA_OVERFLOW_MENU: InjectionKey<OverflowMenu> = Symbol("SCAOverflowMenu");
